import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

// Accept ALL dynamic filters
export const partner_registerApi = createAsyncThunk(
  "partner_register",
  async (filters = {}) => {
    // filters may include:
    // { PartnerName, EntityName, PartnerCode, Mobile, startDate, endDate }

    const params = {};

    // Add only the fields that are passed
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        params[key] = filters[key];
      }
    });

    const response = await axiosInstance.get("/partner_register", {
      params,
    });
    return response.data;
  },
);

const partner_registerSlice = createSlice({
  name: "partner_register",
  initialState: {
    partner_register: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partner_registerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(partner_registerApi.fulfilled, (state, action) => {
        state.partner_register = action.payload;
        state.loading = false;
      })
      .addCase(partner_registerApi.rejected, (state, action) => {
        state.errors.push(action.error?.message);
        state.loading = false;
      });
  },
});

export default partner_registerSlice.reducer;

// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axiosInstance";

// // Modify the thunk to accept search parameters for name, startDate, and endDate
// export const partner_registerApi = createAsyncThunk(
//   "partner_register",
//   async ({ name = "", startDate = "", endDate = "" }) => {
//     const params = {};

//     // Add name to the query if provided
//     if (name) {
//       params.name = name;
//     }

//     // Add date range to the query if provided
//     if (startDate) {
//       params.startDate = startDate;
//     }
//     if (endDate) {
//       params.endDate = endDate;
//     }

//     // Call the API with the necessary query parameters
//     const response = await axiosInstance.get("/partner_register", {
//       params, // Pass the parameters to the API request
//     });
//     return response.data;
//   }
// );

// const partner_registerSlice = createSlice({
//   name: "partner_register",
//   initialState: {
//     partner_register: [],
//     errors: [],
//     loading: false,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(partner_registerApi.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(partner_registerApi.fulfilled, (state, action) => {
//         state.partner_register = action.payload;
//         state.loading = false;
//       })
//       .addCase(partner_registerApi.rejected, (state, action) => {
//         state.errors.push(action.error.message);
//         state.loading = false;
//       });
//   },
// });

// export default partner_registerSlice.reducer;
